/**
 * File name utilities for Uppy file uploads with reference ID handling.
 *
 * Background:
 * Uppy's file ID generation uses the file name as part of the unique identifier.
 * In no-code scenarios, we include blockId in the referenceId to allow different files
 * to be uploaded across blocks.
 *
 * Problem:
 * When a user uploads a file on a slow connection (e.g., 3G) and the upload is incomplete,
 * uploading the same file again from a different block results in the same fileId.
 * This causes Uppy to update the file.meta.referenceId to the new block id,
 * leaving the original block's upload stuck/orphaned.
 *
 * Solution:
 * We prefix the file name with referenceId BEFORE Uppy calls generateFileId to ensure
 * unique file IDs per block. After the file is added to Uppy, we remove the referenceId
 * prefix from the display name to maintain clean file names for the user.
 */

function addReferenceIdToFileName(fileName: string, referenceId?: string) {
  return referenceId ? `${referenceId}_${fileName}` : fileName;
}

function removeReferenceIdFromFileName(fileName?: string, referenceId?: string) {
  return referenceId && fileName ? fileName.replace(`${referenceId}_`, '') : fileName;
}

export { addReferenceIdToFileName, removeReferenceIdFromFileName };
